import { AxiosResponse } from 'axios';
import { http } from '@/services/http.service';
import { ILeague } from '@/types/general';

export const create = (league: ILeague): Promise<AxiosResponse> => {
  console.log('createLeague http request...')
  return http.post('/api/leagues', { league });
};

export const fetchAll = (account_id, include_interleague): Promise<AxiosResponse> => {
  return http.get(`/api/leagues`, { params: { account_id: account_id, include_interleague: include_interleague } })
};

export const fetch = (id): Promise<AxiosResponse> => {
  return http.get(`/api/leagues/${id}`);
};

export const getWaivers = (league_id, language): Promise<AxiosResponse> => {
  return http.get(`/api/leagues/waivers`, { params: { league_id: league_id, language: language } } )
}

// export const register = (user: IRegisterUser): Promise<AxiosResponse> => {
//   return http.post('users/signup', { user });
// };
